import React from 'react'
import './Login.css'
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { login } from '../../../actions/auth/auth'
import { Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../subComponents/Loader';
import logo from "../../../assets/images/fflogo.svg";
import Visibility from '@mui/icons-material/VisibilityOutlined';
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined';
import login_ellipse from "../../../assets/images/login_ellipse.svg";
import login_triangle from "../../../assets/images/login_triangle.svg";
import { DOWNLOAD_APP_URL } from '../../../Constatns';
import { Copyright } from 'lucide-react';
import {t} from '../../../locales/translate.js'

function Login() {
  const initialValues = { email: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const download_app = DOWNLOAD_APP_URL;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const user = JSON.parse(localStorage.getItem("user"));


  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        loginHandle();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [formValues]);

  const currentYear = new Date().getFullYear();

  const loginHandle = async () => {
    const errors = validate(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      dispatch(login(formValues.email.trim().toLowerCase(), formValues.password));
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (user && !user.status) {
      localStorage.clear();
    }
  }

  const validate = (values) => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!emailRegex.test(values.email.trim())) {
      errors.email = "Invalid email!";
    }
    if (!values.password) {
      errors.password = "Password is required!";
    }
    return errors;
  }

  if (user && user.status) {
    return <Redirect to="/admin" />
  }

  return (
    <>
      {user && !user.status && <ToastContainer />}
      <div className="login-page">
        <div className="left-section">
          <img src={login_triangle} alt="Triangle" className="illustration-triangle" />
          <img src={login_ellipse} alt="Ellipse" className="illustration-ellipse" />
          <div className="left-text">
            <h1 className="left-heading">{t('tagline')}</h1>
            <p className="left-subtext">{t('subtext')}</p>
          </div>
          <div className="powered-by-text">
            <p>Powered by <u><i>Big Entities</i></u></p>
          </div>
        </div>
        <div className="right-section">
          <div className="logo-wrapper">
            <img src={logo} alt="Logo" />
          </div>

          <div className="form-wrapper">
            <div className={`form-fields ${Object.keys(formErrors).length > 0  ? 'form-gap-error' : 'form-gap-normal'}`}>
              <div className="email">
                <div className="email-field">
                  <label htmlFor="email" className="email-field-label">{t('emailLabel')}</label>
                  <div className="email-field-input-wrapper">
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder={t('emailPlaceholder')}
                      value={formValues.email}
                      onChange={handleChange}
                      className="email-input"
                    />
                  </div>
                  {formErrors.email && <p className="email-field-error">{formErrors.email}</p>}
                </div>
              </div>

              <div className="password">
                <div className="password-field">
                  <label htmlFor="password" className="password-label">{t('passwordLabel')}</label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      placeholder={t('passwordPlaceholder')}
                      value={formValues.password}
                      onChange={handleChange}
                      className="password-input"
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </button>
                  </div>
                  {formErrors.password && <p className="password-error">{formErrors.password}</p>}
                </div>
              </div>

              <div className="password-options">
                <a href="/forgotPassword" className="password-forgot">{t('forgotPassword')}</a>
              </div>

              <button
                type="button"
                onClick={loginHandle}
                disabled={auth.isLogging}
                className="login-button-custom"
              >
                {auth.isLogging ? (
                  <div className="login-button-loader">
                    <Loader />
                  </div>
                ) : (
                  <span>
                    {t("signIn")}
                  </span>
                )}
              </button>
            </div>

            <div>
              {/* <div className="need-help-text">
                <p>Need Help?</p>
              </div> */}
              <div className="copyright-text">
                <p style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <Copyright height={16} width={16} />
                  {t('copyrightText')} {currentYear}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
